import React from "react"
import ReactWOW from "react-wow"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import IconDollar from "../../assets/images/smsf/logo-dollar.svg"
import IconCalc from "../../assets/images/smsf/logo-calculator.svg"
import IconLocation from "../../assets/images/smsf/icon-location.svg"
import Available from "../../assets/images/smsf/available.svg"
import Residential from "../../assets/images/smsf/residential.svg"
import NoFee from "../../assets/images/smsf/noFee.svg"
import Easy from "../../assets/images/smsf/easy.svg"
import Fast from "../../assets/images/smsf/fast.svg"

const Banner = props => {
  return (
    <div className="home-hero-banner-revamp">
      <div className="container hero mb-xl-5">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-12 mt-5 d-flex justify-content-center align-items-center flex-column py-5">
            <div className="hero-title-wrapper mt-5">
              <h1 className="hero-title">
                Great SMSF Rates
                <span className=""> Start Here!</span>
                <ReactWOW delay=".5s" animation="fadeInDown">
                  <sup className=""> TM</sup>
                </ReactWOW>
              </h1>
            </div>
            <h2 className="mb-4">Experts in SMSF Property Lending.</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-9 col-md-6 mt-md-0 mt-4">
            <div className="row">
              <div className="col-xl-6 col-md-12">
                <ReactWOW delay=".05s" animation="fadeInUp">
                  {/* <h2 className="low-rate-title mt-4 mb-2">Low Rate SMSF Loans​</h2> */}
                  <div className="d-flex justify-content-center h-100">
                    <div className="rates-comparison">
                      <div className="green-corona"></div>
                      <div className="rates-comparison-wapper">
                        <div className="rates-group">
                          <label>Interest Rate from</label>
                          <div className="rate-wrapper-interest">
                            <h2 className="rate">{props.HeroValue}</h2>
                            <div className="percentage">
                              <p className="percentage-symbol">
                                % <span>p.a</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="rates-comparison-group">
                          <label>Comparison Rate*</label>
                          <div className="rate-wrapper-comparison">
                            <h2 className="rate">{props.ComparisonRate}</h2>
                            <div className="percentage">
                              <p className="percentage-symbol">
                                % <span>p.a</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-center align-items-center mt-3">
                          <p className="no-hidden-fees">NO HIDDEN FEES</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <p className="low-rate-description mt-3">​​​Oxygen has some of the lowest rate SMSF loans in the market, whether you want to refinance an existing loan or purchase a new property. Check out our range of low rate SMSF loans and start saving thousands today!</p> */}
                </ReactWOW>
              </div>
              <div className="col-xl-6 col-md-12 mt-xl-0 mt-4">
                <div className="calculator-tile">
                  <h2 className="">Our Key Features</h2>
                  <div className="banner-list">
                    <div className="my-3 d-flex align-items-center">
                      <span className="mr-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Rectangle_1674"
                                data-name="Rectangle 1674"
                                width="20"
                                height="20"
                                transform="translate(139 369)"
                                fill="#fff"
                                stroke="#707070"
                                stroke-width="1"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Mask_Group_3"
                            data-name="Mask Group 3"
                            transform="translate(-139 -369)"
                            clip-path="url(#clip-path)"
                          >
                            <g
                              id="speech-bubble"
                              transform="translate(139 369.137)"
                            >
                              <g
                                id="Group_1504"
                                data-name="Group 1504"
                                transform="translate(0 0)"
                              >
                                <path
                                  id="Path_3118"
                                  data-name="Path 3118"
                                  d="M10.077.205A9.99,9.99,0,0,0,0,10.156v8.862a.92.92,0,0,0,.926.913H9.911A9.99,9.99,0,0,0,20,9.993,9.932,9.932,0,0,0,10.077.205Z"
                                  transform="translate(0 -0.205)"
                                  fill="#00b3e6"
                                />
                              </g>
                              <g
                                id="Group_1505"
                                data-name="Group 1505"
                                transform="translate(0 4.429)"
                              >
                                <path
                                  id="Path_3119"
                                  data-name="Path 3119"
                                  d="M18.346,6.849A15.46,15.46,0,0,1,3.36,18.523,15.5,15.5,0,0,1,0,18.156v3.077a.92.92,0,0,0,.926.913H9.911A9.99,9.99,0,0,0,20,12.207a9.72,9.72,0,0,0-1.654-5.358Z"
                                  transform="translate(0 -6.849)"
                                  fill="#0a95bd"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <span className="b-list-item">100% Offset account​</span>
                    </div>
                    <div className="my-3 d-flex align-items-center">
                      <span className="mr-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Rectangle_1674"
                                data-name="Rectangle 1674"
                                width="20"
                                height="20"
                                transform="translate(139 369)"
                                fill="#fff"
                                stroke="#707070"
                                stroke-width="1"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Mask_Group_3"
                            data-name="Mask Group 3"
                            transform="translate(-139 -369)"
                            clip-path="url(#clip-path)"
                          >
                            <g
                              id="speech-bubble"
                              transform="translate(139 369.137)"
                            >
                              <g
                                id="Group_1504"
                                data-name="Group 1504"
                                transform="translate(0 0)"
                              >
                                <path
                                  id="Path_3118"
                                  data-name="Path 3118"
                                  d="M10.077.205A9.99,9.99,0,0,0,0,10.156v8.862a.92.92,0,0,0,.926.913H9.911A9.99,9.99,0,0,0,20,9.993,9.932,9.932,0,0,0,10.077.205Z"
                                  transform="translate(0 -0.205)"
                                  fill="#00b3e6"
                                />
                              </g>
                              <g
                                id="Group_1505"
                                data-name="Group 1505"
                                transform="translate(0 4.429)"
                              >
                                <path
                                  id="Path_3119"
                                  data-name="Path 3119"
                                  d="M18.346,6.849A15.46,15.46,0,0,1,3.36,18.523,15.5,15.5,0,0,1,0,18.156v3.077a.92.92,0,0,0,.926.913H9.911A9.99,9.99,0,0,0,20,12.207a9.72,9.72,0,0,0-1.654-5.358Z"
                                  transform="translate(0 -6.849)"
                                  fill="#0a95bd"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <span className="b-list-item">
                        Residential & Commercial Properties
                      </span>
                    </div>
                    <div className="my-3 d-flex align-items-center">
                      <span className="mr-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Rectangle_1674"
                                data-name="Rectangle 1674"
                                width="20"
                                height="20"
                                transform="translate(139 369)"
                                fill="#fff"
                                stroke="#707070"
                                stroke-width="1"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Mask_Group_3"
                            data-name="Mask Group 3"
                            transform="translate(-139 -369)"
                            clip-path="url(#clip-path)"
                          >
                            <g
                              id="speech-bubble"
                              transform="translate(139 369.137)"
                            >
                              <g
                                id="Group_1504"
                                data-name="Group 1504"
                                transform="translate(0 0)"
                              >
                                <path
                                  id="Path_3118"
                                  data-name="Path 3118"
                                  d="M10.077.205A9.99,9.99,0,0,0,0,10.156v8.862a.92.92,0,0,0,.926.913H9.911A9.99,9.99,0,0,0,20,9.993,9.932,9.932,0,0,0,10.077.205Z"
                                  transform="translate(0 -0.205)"
                                  fill="#00b3e6"
                                />
                              </g>
                              <g
                                id="Group_1505"
                                data-name="Group 1505"
                                transform="translate(0 4.429)"
                              >
                                <path
                                  id="Path_3119"
                                  data-name="Path 3119"
                                  d="M18.346,6.849A15.46,15.46,0,0,1,3.36,18.523,15.5,15.5,0,0,1,0,18.156v3.077a.92.92,0,0,0,.926.913H9.911A9.99,9.99,0,0,0,20,12.207a9.72,9.72,0,0,0-1.654-5.358Z"
                                  transform="translate(0 -6.849)"
                                  fill="#0a95bd"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <span className="b-list-item">Non Bank Lender</span>
                    </div>
                    <div className="my-3 d-flex align-items-center">
                      <span className="mr-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Rectangle_1674"
                                data-name="Rectangle 1674"
                                width="20"
                                height="20"
                                transform="translate(139 369)"
                                fill="#fff"
                                stroke="#707070"
                                stroke-width="1"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Mask_Group_3"
                            data-name="Mask Group 3"
                            transform="translate(-139 -369)"
                            clip-path="url(#clip-path)"
                          >
                            <g
                              id="speech-bubble"
                              transform="translate(139 369.137)"
                            >
                              <g
                                id="Group_1504"
                                data-name="Group 1504"
                                transform="translate(0 0)"
                              >
                                <path
                                  id="Path_3118"
                                  data-name="Path 3118"
                                  d="M10.077.205A9.99,9.99,0,0,0,0,10.156v8.862a.92.92,0,0,0,.926.913H9.911A9.99,9.99,0,0,0,20,9.993,9.932,9.932,0,0,0,10.077.205Z"
                                  transform="translate(0 -0.205)"
                                  fill="#00b3e6"
                                />
                              </g>
                              <g
                                id="Group_1505"
                                data-name="Group 1505"
                                transform="translate(0 4.429)"
                              >
                                <path
                                  id="Path_3119"
                                  data-name="Path 3119"
                                  d="M18.346,6.849A15.46,15.46,0,0,1,3.36,18.523,15.5,15.5,0,0,1,0,18.156v3.077a.92.92,0,0,0,.926.913H9.911A9.99,9.99,0,0,0,20,12.207a9.72,9.72,0,0,0-1.654-5.358Z"
                                  transform="translate(0 -6.849)"
                                  fill="#0a95bd"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <span className="b-list-item">Established 22 Years</span>
                    </div>
                  </div>
                  <a
                    className="accountant-login-container d-flex justify-content-start align-items-center"
                    href={`${process.env.GATSBY_SMSF_BASE_URL}`}
                    target="_blank"
                  >
                    <div className="logo-container d-flex mr-2">
                      {/* commented out until class integration */}
                      <div className="class-logo"></div>
                      <div className="vertical-split plr-2"></div>
                      <div className="bgl-logo ml-2"></div>
                    </div>
                    <a
                      href={`${process.env.GATSBY_SMSF_BASE_URL}`}
                      target="_blank"
                      className="login-link"
                    >
                      Accountant login
                    </a>
                  </a>
                  <div className="smsf-accredited-container">
                    <div className="smsf-accredited"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mt-md-0 mt-4 mini-form">
            <div className="white-puncture-bottom"></div>
            <h2>Quick Links</h2>
            <ReactWOW delay=".05s" animation="fadeInUp">
              <div class="d-flex flex-column ustify-content-center align-items-center">
                <a
                  href={`${process.env.GATSBY_SMSF_BASE_URL}Quote/Full/Fund`}
                  target="_blank"
                  className="default-btn calculator-btn mb-3"
                >
                  {/* <div class="icon-dollar"></div> */}
                  <img
                    src={IconDollar}
                    alt="Icon"
                    class="icon-calculators mr-1"
                  ></img>
                  Quick Quote
                </a>
                <Link
                  to="/calculators/smsf-property-calculator"
                  className="default-btn calculator-btn mb-3"
                >
                  <img
                    src={IconCalc}
                    alt="Icon"
                    class="icon-calculators mr-2"
                  ></img>
                  SMSF Property Tool
                </Link>
                <Link
                  to="/location-checker"
                  className="default-btn calculator-btn mb-3"
                >
                  <img
                    src={IconLocation}
                    alt="Icon"
                    class="icon-calculators mr-2"
                  ></img>
                  Location Checker
                </Link>
              </div>
              <div className="btn-box-new">
                <span>
                  <a
                    href="/applynow"
                    className="default-btn secondary-btn btn-lg"
                  >
                    <div className="d-flex align-items-center">
                      <div className="r-part">It's Free</div>
                      <div className="m-part"> Apply Now</div>
                    </div>
                  </a>
                </span>
              </div>
            </ReactWOW>
          </div>
        </div>
      </div>
      <div className="container hero my-xl-5">
        <section className="home-cat-section mt-xl-0 mt-5">
          <ReactWOW delay=".05s" animation="fadeInUp">
            <div className="row justify-content-center justify-content-md-center justify-content-lg-between">
              <div className="col-10 col-md-4 col-lg-2 mb-5 mb-md-4 mb-lg-0">
                <div className="icon-text-group">
                  <img
                    src={Available}
                    alt="Available for Purchase & Refinancee"
                  />
                  <p>Available for Purchase & Refinance</p>
                </div>
              </div>
              <div className="col-10 col-md-4 col-lg-2 mb-5 mb-md-4 mb-lg-0">
                <div className="icon-text-group">
                  <img
                    src={Residential}
                    alt="Residential & Commercial Properties"
                  />
                  <p>Residential & Commercial Properties​</p>
                </div>
              </div>
              <div className="col-10 col-md-4 col-lg-2 mb-5 mb-md-4 mb-lg-0">
                <div className="icon-text-group">
                  <img
                    src={NoFee}
                    alt="No application fee & no settlement fee"
                  />
                  <p>No application fee & no settlement fee​</p>
                </div>
              </div>
              <div className="col-10 col-md-4 col-lg-2 mb-5 mb-md-0 mb-lg-0">
                <div className="icon-text-group">
                  <img src={Easy} alt="Easy Application process" />
                  <p>Easy Application process​</p>
                </div>
              </div>
              <div className="col-10 col-md-4 col-lg-2 mb-0 mb-md-0 mb-lg-0">
                <div className="icon-text-group">
                  <img src={Fast} alt="Fast & simple Refinance approvals​<" />
                  <p>Fast & simple Refinance approvals​</p>
                </div>
              </div>
            </div>
          </ReactWOW>
        </section>
      </div>
    </div>
  )
}

export default Banner
